import { Component, OnInit } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { PersonsPerSquareMeterComponent } from 'src/app/models/components/commonComponents/PersonsPerSquareMeterComponent';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-aisle',
  templateUrl: './aisle.component.html',
  styleUrls: ['./aisle.component.scss']
})
export class AisleViewComponent extends BaseAdvancedPropertyViewComponent {
  personsPerSquareMeterComponent: PersonsPerSquareMeterComponent = new PersonsPerSquareMeterComponent();

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.personsPerSquareMeterComponent = getComponentFromSource(ComponentNames.personsPerSquareMeterComponent, this.items);
  }

  saveButtonDisabledState(): boolean {
    return false;
  }
}
